<template>
  <!-- 仓埠考场专用功能 -->
  <div>
    <div class="main-title">教练指纹记录</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="add()">添加指纹记录</el-button>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchParams)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索姓名拼音/身份证/手机号"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              style="width:250px;"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <!--
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          -->
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        style="width:100%">
        <el-table-column
          prop="company_name"
          label="所属科目"
          width="100">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          width="80">
        </el-table-column>
        <el-table-column
          prop="idcard"
          label="身份证号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="f_date"
          label="记录日期"
          width="160">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="300">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="print(scope.row)">打印</el-button>
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
            <el-button type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加/修改 -->
    <el-dialog :title="form.id > 0 ? '修改指纹记录' : '添加指纹记录'" :visible.sync="formVisible">
      <el-form :model="form" ref="form" :rules="formRules" label-width="200px">
        <el-form-item prop="company_id" label="所属科目">
          <el-select
            v-model="form.company_id"
            placeholder="选择科目"
            style="width:194px;">
            <el-option
              v-for="item in companyList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="name" label="教练姓名">
          <el-input v-model="form.name" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="form.idcard" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.phone" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="记录日期">
          <el-date-picker style="width:194px;" v-model="form.f_date" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" style="width:100%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="commit" :loading="commiting">确 定</el-button>
        <el-button @click="formVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
export default {
  props: {
    user: Object
  },
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      sqlcode: 'coach_finger_sy',
      searchForm: {
        company_ids: [],
        query: '',
        daterange: []
      },
      form: {
        id: 0,
        name: '',
        phone: '',
        idcard: '',
        company_id: 1,
        f_date: new Date(),
        remark: ''
      },
      formRules: {
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' }
        ]
      },
      formVisible: false,
      commiting: false,
      companyList: []
    }
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  mounted () {
    this.fetchCompanyList()
  },
  methods: {
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
        }
      })
    },
    add () {
      this.form = {
        id: 0,
        name: '',
        phone: '',
        idcard: '',
        company_id: 1,
        f_date: new Date(),
        remark: ''
      },
      this.formVisible = true
    },
    edit (row) {
      this.form = {
        id: row.id,
        name: row.name,
        phone: row.phone,
        idcard: row.idcard,
        company_id: row.company_id,
        f_date: row.f_date,
        remark: row.remark
      },
      this.formVisible = true
    },
    commit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.name_pinyin = this.form.name_py = this.form.name
          if (this.form.id === 0) {
            this.$http.get('/dbapi/coach_finger_sy?name=' + this.form.name).then(response => {
              if (!response.data.success) {
                this.$message({
                  type: 'error',
                  message: response.data.message
                })
                return
              }
              if (response.data.list.length > 0) {
                this.$message({
                  type: 'error',
                  message: '教练' + this.form.name + '已存在,请检查'
                })
                return
              }
              this.post('/dbapi/coach_finger_sy_insert', this.form)
            })
          } else {
            this.post('/dbapi/coach_finger_sy_update', this.form)
          }
        }
      })
    },
    post (url, data) {
      this.commiting = true
      this.$http.post(url, data).then(response => {
        this.commiting = false
        if (response.data.success) {
          this.formVisible = false
          this.$message({
            type: 'success',
            message: '保存成功'
          })
          this.refresh()
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    del (row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/coach_finger_sy_del', {
          id: row.id
        }).then(response => {
          if (response.data.success) {
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    print (row) {
      window.open(this.$http.receiptBaseUrl + '/coach_finger_sy?id=' + row.id + '&token=' + localStorage.getItem('kaochang.token'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data/CoachFingerSy.vue